import { collectionEngineV1 } from '../apis.js';
const billingsAPI = collectionEngineV1('/billings');
export const getOngoingWork = (q) => billingsAPI('GET', `/ongoing-work?${q?.creditorId ? `creditorId=${q.creditorId}` : ''}${q?.creditorId && q.caseId ? '&' : ''}${q?.caseId ? `caseId=${q.caseId}` : ''}`);
export const getCollections = (q) => billingsAPI('GET', `/collections?${q?.creditorId ? `creditorId=${q.creditorId}` : ''}${q?.creditorId && q.caseId ? '&' : ''}${q?.caseId ? `caseId=${q.caseId}` : ''}`);
export const createBillingCollection = (newBillingCollection) => billingsAPI('POST', '/collections', {
    body: newBillingCollection,
});
export const sendBillings = (billingIds) => billingsAPI('POST', '/send', {
    body: {
        billingIds,
    },
});
export const addToPayouts = (billingId) => billingsAPI('POST', `/${billingId}/add-to-payouts`, {
    body: {},
});
export const getById = (billingId) => billingsAPI('GET', `/${billingId}`);
export const deleteById = (billingId) => billingsAPI('DELETE', `/${billingId}`);
export const getMultiple = (query) => billingsAPI('GET', `/?${query?.caseId ? `caseId=${query.caseId}` : ''}${query?.creditorId ? `&creditorId=${query.creditorId}` : ''}${query?.depositCaseVoucherId
    ? `&depositCaseVoucherId=${query.depositCaseVoucherId}`
    : ''}${query?.billingCollectionId
    ? `&billingCollectionId=${query.billingCollectionId}`
    : ''}${query?.currency ? `&currency=${query.currency}` : ''}${query?.billingAppendixId
    ? `&billingAppendixId=${query.billingAppendixId}`
    : ''}`);
export const billingSelectorToQueryString = (billingSelector) => {
    console.log(billingSelector);
    return `billingAppendixId=${billingSelector.billingAppendixId}&creditorId=${billingSelector.creditorId}&currency=${billingSelector.currency}&isAdjustment=${billingSelector.isAdjustment}${billingSelector.caseId ? `&caseId=${billingSelector.caseId}` : ''}${billingSelector.billAfter !== undefined
        ? `&billAfter=${billingSelector.billAfter}`
        : ''}${typeof billingSelector.caseEnded === 'boolean'
        ? `&caseEnded=${billingSelector.caseEnded}`
        : ''}${typeof billingSelector.billingPrevented === 'boolean'
        ? `&billingPrevented=${billingSelector.billingPrevented}`
        : ''}`;
};
export const getByBillingSelector = (billingSelector) => billingsAPI('GET', `/ongoing-work-billing?${billingSelectorToQueryString(billingSelector)}`);
//# sourceMappingURL=billing.js.map